import React from "react";
import { Card, Stack, Skeleton } from "@mui/material";

const CardSkeleton = ({ height = 40, width = "100%", count = 1, sx = {} }) => {
  return (
    <Stack spacing={2}>
      {[...Array(count)].map((_, idx) => (
        <Card key={idx} variant="outlined" sx={{ p: 2, width, ...sx }}>
          <Skeleton variant="rectangular" height={height} width="100%" />
          <Skeleton variant="text" width="60%" sx={{ mt: 2 }} />
          <Skeleton variant="text" width="40%" />
        </Card>
      ))}
    </Stack>
  );
};

export default CardSkeleton;
